import { render } from "./LotsInProgressPage.vue?vue&type=template&id=4b2790a4&scoped=true"
import script from "./LotsInProgressPage.vue?vue&type=script&lang=js"
export * from "./LotsInProgressPage.vue?vue&type=script&lang=js"

import "./LotsInProgressPage.vue?vue&type=style&index=0&id=4b2790a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2790a4"]])

export default __exports__